import axios from "../../helpers/httpClient";
import { updateAmountWithCurrency } from './componentsActions';

export default {
    getEmployees: async ({ commit, state, dispatch }, obj) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const movements = await axios.get(`/information/private/management/getEmployees`, {
                params: {
                    perPage: (obj) ? obj.perPage : 40,
                    currentPage: (obj) ? obj.currentPage : 1,
                    dataFilter: (obj) ? obj.dataFilter : {}
                }
            }, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (movements.status === 200) {
                const obj = {
                    array: movements.data.employees,
                    property: 'Salario_bruto'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', newStateData);
                commit('SET_EMPLEADOS_FILTROS', newStateData);

                commit('SET_EMPLEADOS_EXPORT', newStateData);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', newStateData);

                commit('SET_TOTAL_PERSONAL', movements.data.totalCoincidences);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addEmployee: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateEmployees = state.empleados;

            const employeeAdded = await axios.post("/information/private/management/addEmployee", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (employeeAdded.status === 200) {
                stateEmployees.push(employeeAdded.data.data)

                const obj = {
                    array: stateEmployees,
                    property: 'Salario_bruto'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', newStateData);
                commit('SET_EMPLEADOS_FILTROS', newStateData);

                commit('SET_EMPLEADOS_EXPORT', newStateData);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', newStateData);

                dispatch('activeMessageCorrect', employeeAdded.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editEmployee: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateEmployees = state.empleados;

            const employeeEdited = await axios.post("/information/private/management/editEmployee", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (employeeEdited.status === 200) {
                stateEmployees.forEach((data, index) => {
                    if (data.Id_empleado === employeeEdited.data.data[0].Id_empleado) {
                        Object.assign(stateEmployees[index], employeeEdited.data.data[0])
                    }
                })

                const obj = {
                    array: stateEmployees,
                    property: 'Salario_bruto'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', newStateData);
                commit('SET_EMPLEADOS_FILTROS', newStateData);

                commit('SET_EMPLEADOS_EXPORT', newStateData);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', newStateData);

                dispatch('activeMessageCorrect', employeeEdited.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    updateWorkDoneEmployee: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateEmployees = state.empleados;

            const employeeEdited = await axios.post("/information/private/management/updateWorkDoneEmployee", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (employeeEdited.status === 200) {
                stateEmployees.forEach((data, index) => {
                    if (data.Id_empleado === employeeEdited.data.data[0].Id_empleado) {
                        Object.assign(stateEmployees[index], employeeEdited.data.data[0])
                    }
                })

                const obj = {
                    array: stateEmployees,
                    property: 'Salario_bruto'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', newStateData);
                commit('SET_EMPLEADOS_FILTROS', newStateData);

                commit('SET_EMPLEADOS_EXPORT', newStateData);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', newStateData);

                dispatch('activeMessageCorrect', employeeEdited.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteEmployee: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateEmployees = state.empleados;
            
            const employeeDeleted = await axios.post("/information/private/management/deleteEmployee", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (employeeDeleted.status === 200) {
                const newEmployees = stateEmployees.filter((employee) => employee.Id_empleado !== payload.Id_empleado)

                const obj = {
                    array: newEmployees,
                    property: 'Salario_bruto'
                };

                let newStateData = await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', newStateData);
                commit('SET_EMPLEADOS_FILTROS', newStateData);

                commit('SET_EMPLEADOS_EXPORT', newStateData);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', newStateData);

                dispatch('activeMessageCorrect', employeeDeleted.data.message)
                return employeeDeleted
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addEmployeesImport: async ({ commit, state, dispatch }, allEmpleados) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateEmployees = state.empleados;

            const newEmpleados = await axios.post(`/information/private/management/addEmployeesImport`, {
                allEmpleados,
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (newEmpleados.status === 200) {
                stateEmployees.push(newEmpleados.data.data)

                const obj = {
                    array: stateEmployees,
                    property: 'Salario_bruto'
                };
                await dispatch('updateAmountWithCurrency', obj);

                commit('SET_EMPLEADOS', stateEmployees);
                commit('SET_EMPLEADOS_FILTROS', stateEmployees);
                
                commit('SET_EMPLEADOS_EXPORT', stateEmployees);
                commit('SET_EMPLEADOS_FILTERS_EXPORT', stateEmployees);

                dispatch('activeMessageCorrect', newEmpleados.data.message)
                return 'ok'
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    getDepartments: async ({ commit, state, dispatch }) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const departments = await axios.get(`/information/private/management/getDepartments`, {
                params: {}}, {
                headers: { 'Content-Type': 'application/json' }
            })

            // Stop Loader
            commit('SET_LOADER', false);

            if (departments.status === 200) {
                commit('SET_DEPARTMENTS', departments.data.departments);
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    addDepartment: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateDepartments = state.departments;

            const departmentAdded = await axios.post("/information/private/management/addDepartment", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (departmentAdded.status === 200) {
                stateDepartments.push(departmentAdded.data.data)

                commit('SET_DEPARTMENTS', stateDepartments);

                dispatch('activeMessageCorrect', departmentAdded.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    editDepartment: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateDepartments = state.departments;

            const departmentEdited = await axios.post("/information/private/management/editDepartment", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (departmentEdited.status === 200) {
                stateDepartments.forEach((data, index) => {
                    if (data.Id_departamento === departmentEdited.data.data[0].Id_departamento) {
                        Object.assign(stateDepartments[index], departmentEdited.data.data[0])
                    }
                })

                commit('SET_DEPARTMENTS', stateDepartments);

                dispatch('activeMessageCorrect', departmentEdited.data.message)
            }
        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },

    deleteDepartment: async ({ commit, state, dispatch }, payload) => {
        try {
            // Start loader
            commit('SET_LOADER', true);

            const stateDepartments = state.departments;
            
            const departmentDeleted = await axios.post("/information/private/management/deleteDepartment", payload)

            // Stop Loader
            commit('SET_LOADER', false);

            if (departmentDeleted.status === 200) {
                const newDepartments = stateDepartments.filter((dep) => dep.Id_departamento !== payload.Id_departamento)

                commit('SET_DEPARTMENTS', newDepartments);

                dispatch('activeMessageCorrect', departmentDeleted.data.message)
            }

        } catch (error) {
            // Stop Loader
            commit('SET_LOADER', false);

            console.log(error)
            if (error?.response) {
                console.log(error?.response)
                dispatch('activeMessageError', (error.response !== undefined)
                    ? error?.response?.data?.message || error?.response?.data?.msg
                    : 'ERROR'
                )
            } else {
                dispatch('activeMessageError', 'ERROR')
                console.log(error)
            }
            return
        }
    },
}